import { IHeActionTypes, eHeActionTypeIds } from "../../action-types/category/IHeActionType";
import { IHeReducer } from "../../reducer-model/category/IHeReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IHeReducer = {
    status: eReducerStatusBase.is_not_initialization,
    hes: []
}
export const heReducer = (state: IHeReducer=iniState, action: IHeActionTypes): IHeReducer => {
    switch (action.type) {
        case eHeActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case eHeActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                hes: action.payload
            }
        case eHeActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return {
                ...state
            };
    }
}